import React, { Fragment } from "react";

import { Typography } from "@material-ui/core";
import { get } from "lodash";
import moment from "moment";
import { useTranslate } from "ra-core";

const PeriodField = ({ record }) => {
  const translate = useTranslate();
  const format = translate("app.date_format.short");
  const fromDate = moment(get(record, "from_date"));
  const toDate = moment(get(record, "to_date"));
  const number = get(record, "number");
  return (
    <Fragment>
      <Typography variant="subtitle1">
        {translate(
          "resources.intermediate-technical-reports.fields.number_title",
          { number }
        )}
      </Typography>
      {fromDate.isValid() && toDate.isValid() && (
        <Typography variant="body1">
          {fromDate.format(format)} - {toDate.format(format)}
        </Typography>
      )}
    </Fragment>
  );
};

export default PeriodField;
